import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getNaturalezasDeIngreso } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const NaturalezaDeIngresos = ({ permission }) => (
  <PlainCRUD
    title="Naturalezas de Ingresos"
    permission={permission}
    get={getNaturalezasDeIngreso}
    fields={[defaultFields.descripcion]}
    readOnly
  />
);

export default NaturalezaDeIngresos;
